import { render } from "./RadarChart.vue?vue&type=template&id=ecaae08e&scoped=true"
import script from "./RadarChart.vue?vue&type=script&lang=js"
export * from "./RadarChart.vue?vue&type=script&lang=js"

import "./RadarChart.vue?vue&type=style&index=0&id=ecaae08e&lang=scss&scoped=true"
import "./RadarChart.vue?vue&type=style&index=1&id=ecaae08e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecaae08e"]])

export default __exports__